export default {
  title: '登录泛函标注平台',
  username: '用户名或邮箱',
  password: '请输入密码',
  logways1: '使用手机登录',
  logways2: '使用密码登录',
  forgot: '找回密码',
  login: '登录',
  socialAccount: '社交账号登录',
  customerInfo: '有任务，找人难？<br/>全球100000+标注员帮您做！',
  customerIn: '发布者入口',
  userInfo: '上平台赚泛函币？<br/>还等什么，赶紧点击下方入口做任务吧！',
  userIn: '标注员入口',
  js: {
    error: '失败',
    success: '成功'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh/login.js